import * as React from 'react';

export interface ActionsRowProps extends React.HTMLAttributes<HTMLDivElement> {}

export const ActionsRow: React.FC<ActionsRowProps> = (props) => {
  return <div {...props} className={`actions-row ${props.className || ''}`} />;
};
